export default {
    get loginDatas () {
        return JSON.parse(localStorage.getItem('loginDatasStudent') || "{}");
    },
    set loginDatas (value) {
        localStorage.setItem('loginDatasStudent', JSON.stringify(value));
    },
    get UserToken () {
        return localStorage.getItem('tokenStudent');
    },
    set UserToken (value) {
        localStorage.setItem('tokenStudent', value);
    },
    get studentId () {
        return localStorage.getItem('studentId');
    },
    set studentId (value) {
        localStorage.setItem('studentId', value);
    },
    get studentName () {
        return localStorage.getItem('studentName');
    },
    set studentName (value) {
        localStorage.setItem('studentName', value);
    },
    get studentHeadPor () {
        return localStorage.getItem('studentHeadPor');
    },
    set studentHeadPor (value) {
        localStorage.setItem('studentHeadPor', value);
    },
    get studentsList () {
        return JSON.parse(localStorage.getItem('studentsList'));
    },
    set studentsList (value) {
        localStorage.setItem('studentsList', JSON.stringify(value));
    },
    /* 面包屑导航列表 */
    crumbList: []
};



// WEBPACK FOOTER //
// ./src/store/state.js